/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { useGlobal } from '@/store'
import config from '@/config'

const HOSTNAME_VARIABLE = 'eyedoclocator'
const CLIENT_ID_VARIABLE = '$CLIENT_ID'
const LOCALE_VARIABLE = '$LOCALE'
const GROUP_ID_VARIABLE = '$GROUP_ID'
const CLASS_ID_VARIABLE = '$CLASS_ID'
const CLASS_PLAN_VARIABLE = '$CLASSPLAN_ID'
const ENCRYPTED_URL = '$ENCRYPTED_URL'


export default class AppointmentForm {
  private json: any
  public readonly uid: string;
  public readonly title: string
  public readonly description?: string
  public readonly inputPlaceholder: string
  public readonly buttonText: string
  public readonly findProviderUrl: string;
  public readonly invalidZipCodeMessage: string

  constructor (json: any) {
    this.json = json
    this.uid = json.uid
    this.title = json.heading
    this.description = json.description
    this.inputPlaceholder = json.zip_code_placeholder || 'zip code'
    this.buttonText = json.provider_locator_label
    this.invalidZipCodeMessage = json.invalid_zip_message || 'Invalid zip code'
    this.findProviderUrl = this.formatUrl(json.provider_locator_link.href)
  }

  static of (json: any): AppointmentForm {
    return new AppointmentForm(json)
  }

  private formatUrl (url: string): string {
    const global = useGlobal()

    const HOSTNAME = window.location.origin
    const locatorName = url.split('/')[0]
    let hostUrl
    if (HOSTNAME.includes('kbyg') || HOSTNAME.includes('member')) {
      hostUrl = HOSTNAME.replace(/member|kbyg/g, locatorName)
    } else {
      const isTestContentLocation = config.TEST_HOSTS.some(host => HOSTNAME.includes(host))
      hostUrl = isTestContentLocation ? `https://${HOSTNAME_VARIABLE}ashuat.eyemedvisioncare.com` : `https://${HOSTNAME_VARIABLE}.eyemedvisioncare.com`
    }

    url =  url
      .replace(HOSTNAME_VARIABLE, hostUrl)
      .replace(CLIENT_ID_VARIABLE, global.clientId)
      .replace(LOCALE_VARIABLE, global.locale)

    if(global.encryptedURL){
      url = url.replace(/(groupId=\$GROUP_ID&|classId=\$CLASS_ID&|classPlanId=\$CLASSPLAN_ID&)/g, '');
      return url.includes(ENCRYPTED_URL)
         ? url.replace(ENCRYPTED_URL,global.encryptedURL)
         : url.concat(`&search=${global.encryptedURL}`)
    }

    return url
      .replace(GROUP_ID_VARIABLE, global.groupId)
      .replace(CLASS_ID_VARIABLE, global.classId)
      .replace(CLASS_PLAN_VARIABLE, global.classPlanId)
  }
}
